import { useEffect, useRef } from "react";

// Кінець уроку (summary з data.celebrate): конфеті на весь екран + коротка фанфара «ту-ру-ру-ру».
// Без бібліотек: canvas поверх сторінки, не перехоплює кліки; prefers-reduced-motion — лише звук.
const COLORS = ["#FF6B6B", "#FFD93D", "#4D96FF", "#6BCB77", "#FF9F45", "#B983FF", "#FF8FB1"];
const DURATION = 3500;

export default function Celebrate() {
  const ref = useRef(null);

  useEffect(() => {
    const sound = new Audio(`${process.env.PUBLIC_URL}/sounds/celebrate.mp3`);
    sound.volume = 0.6;
    sound.play().catch(() => {}); // автоплей заборонено — просто без звуку

    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return () => sound.pause();
    const canvas = ref.current;
    const ctx = canvas.getContext("2d");
    const dpr = window.devicePixelRatio || 1;
    const resize = () => {
      canvas.width = window.innerWidth * dpr;
      canvas.height = window.innerHeight * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    };
    resize();
    window.addEventListener("resize", resize);

    const W = window.innerWidth;
    const H = window.innerHeight;
    // два «вибухи» знизу з боків + дощ зверху
    const pieces = Array.from({ length: 180 }, (_, i) => {
      const side = i % 3;
      const fromTop = side === 2;
      const angle = fromTop ? Math.PI / 2 : (side === 0 ? -1 : -Math.PI + 1) + (Math.random() - 0.5) * 0.6;
      const speed = fromTop ? 2 + Math.random() * 3 : 11 + Math.random() * 8;
      return {
        x: fromTop ? Math.random() * W : side === 0 ? 0 : W,
        y: fromTop ? -20 - Math.random() * H * 0.5 : H * 0.85,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed,
        w: 6 + Math.random() * 6,
        h: 10 + Math.random() * 8,
        rot: Math.random() * Math.PI,
        vr: (Math.random() - 0.5) * 0.3,
        color: COLORS[i % COLORS.length],
      };
    });

    const start = performance.now();
    let frame;
    const tick = (now) => {
      const t = now - start;
      ctx.clearRect(0, 0, W, H);
      ctx.globalAlpha = t > DURATION - 700 ? Math.max(0, (DURATION - t) / 700) : 1;
      for (const p of pieces) {
        p.vy += 0.25;
        p.vx *= 0.985;
        p.vy *= 0.985;
        p.x += p.vx;
        p.y += p.vy;
        p.rot += p.vr;
        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.w / 2, (-p.h / 2) * Math.abs(Math.cos(p.rot * 2)), p.w, p.h * Math.abs(Math.cos(p.rot * 2)));
        ctx.restore();
      }
      if (t < DURATION) frame = requestAnimationFrame(tick);
      else ctx.clearRect(0, 0, W, H);
    };
    frame = requestAnimationFrame(tick);

    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener("resize", resize);
      sound.pause();
    };
  }, []);

  return (
    <canvas
      ref={ref}
      aria-hidden="true"
      style={{ position: "fixed", inset: 0, width: "100vw", height: "100vh", pointerEvents: "none", zIndex: 9999 }}
    />
  );
}
